/* eslint-disable */
export default {
  activeCall: 'Chiamata attiva',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
